import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableCasino from '../../../../../../@casino/ui/table';
import { setGetMailingStatisticsScrollerUsersWithdrawalsByCurrency } from '../../../../../store/mailing/thunk/setGetMailingStatisticsScrollerUsersWithdrawalsByCurrency';

const CountUsersDeposits = ({
    id,
    currency
}) => {

    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetMailingStatisticsScrollerUsersWithdrawalsByCurrency({
            mailing_id: id,
            currency,
            page: 1,
            pageSize: 25
        }))
    }, []);

    const withdrawals_by_currency = useSelector((state) => state.mailing.scrollers.withdrawals_users_by_currency);

    const columns = [
        { id: 'login', label: 'Логин'},
        { id: 'total_count', label: 'Кол-во выводов'},
        { id: 'total_sum', label: 'Сумма выводов'},
        { id: 'currency', label:  'Валюта'}
    ];

    const handleChange = ({
        page,
        pageSize
    }) => {
        dispatch(setGetMailingStatisticsScrollerUsersWithdrawalsByCurrency({
            mailing_id: id,
            currency,
            page,
            pageSize
        }))
    }

    return (
        <div>
            <div>
                <h3 style={{
                    color: "#FFFFFF",
                    fontWeight: 700,
                }}>Количество и сумма выводов {currency}</h3>
            </div>
            <div style={{borderRadius: 12, background: 'rgb(24, 32, 58)', padding: 20}}>
                <TableCasino
                    width={"100%"}
                    pagination
                    allPage={withdrawals_by_currency.totalPage}
                    perPage={withdrawals_by_currency.pageSize}
                    columns={columns}
                    rows={withdrawals_by_currency.list.map((item) => ({
                        ...item,
                        total_sum: new Intl.NumberFormat('ru-RU').format(item.total_sum),
                        total_count: new Intl.NumberFormat('ru-RU').format(item.total_count),
                    }))}
                    changePage={(v) => {
                        handleChange({
                            page: v.page + 1,
                            pageSize: v.rowsPerPage
                        })
                    }}
                    changeRowsPerPage={(v) => {
                        handleChange({
                            page: 1, 
                            pageSize: v.rowsPerPage,
                        })
                    }}
                />
            </div>
            
        </div >
    )
}

export default CountUsersDeposits;